import type { Microbleed } from "./useMicrobleeds";
import MicrobleedRow from "./MicrobleedRow";

interface Props {
  microbleeds: Microbleed[];
}

function MicrobleedTable({ microbleeds }: Props) {
  const newCount = microbleeds.filter((m) => m.status === "new").length;
  const total = microbleeds.length;

  // NEW first, then by body site for stable order across renders.
  const sorted = [...microbleeds].sort((a, b) => {
    const aNew = a.status === "new" ? 0 : 1;
    const bNew = b.status === "new" ? 0 : 1;
    if (aNew !== bNew) return aNew - bNew;
    return (a.bodySiteDisplay ?? "").localeCompare(b.bodySiteDisplay ?? "");
  });

  return (
    <table
      data-testid="viewer-mode-microbleed"
      className="w-full rounded overflow-x-clip"
    >
      <thead className="bg-stone-600 rounded sticky top-0 z-50">
        <tr>
          <th className="py-2 rounded-tl w-10" />
          <th className="py-2 w-10" />
          <th className="py-2 text-left">Id Microbleed</th>
          <th className="py-2 w-16" />
          <th className="py-2 text-left rounded-tr">Structure</th>
        </tr>
      </thead>
      <tbody>
        <tr className="bg-stone-500 font-semibold">
          <td colSpan={2} className="py-2 text-center">
            T2 star
          </td>
          <td className="py-2 italic"></td>
          <td />
          <td className="py-2 italic">Total: {total}</td>
        </tr>
        {sorted.map((mb, i) => {
          // Prefer backend-supplied longitudinal ID; fall back to sequential.
          const n = mb.number ?? i + 1;
          const displayId = `microbleed_${String(n).padStart(2, "0")}`;
          return (
            <MicrobleedRow key={mb.uid} microbleed={mb} displayId={displayId} />
          );
        })}
      </tbody>
    </table>
  );
}

export default MicrobleedTable;
